import {registerLocalizationStore} from 'epic-react-common';

import Alt from '../alt';

export default registerLocalizationStore(Alt);
